






import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'StormHeader',
  props: {
    image: String,
  },
})
export default class StormHeader extends Vue {
  get getClassBasedOnBreakpoint(): string {
    return `storm-header-${this.$vuetify.breakpoint.name}`;
  }
}
